module.exports = __webpack_public_path__ + "static/media/b.00087bbe.jpg";